/** @file Input fields shared by attachment.createRegion/createMesh (id, name, image, color; no binding). */
import { z } from 'zod';
import { prim } from '@pose2d/format/doc/schemaParts/primitives';

/** id?, name, image (name or id) and color, spread into each create schema; binding is skin.setEntry (W2-30). */
export const createShape = {
  id: z.string().exactOptional(),
  name: z.string().min(1),
  image: z.string().min(1),
  color: prim.hex8.exactOptional(),
};
